import { TableSearch } from "ui/components/Table/TableSearch";
import { memo } from "react";
import { initialDataWithPagination } from "services/api/consts";
import {
  CONTACT_NOTE_SEARCH_COLUMNS,

} from "./consts";
import { ContactNoteSearchResultsProps } from "./types";
import { useTranslate } from "helpers";

const ContactNoteSearchResults: React.FC<ContactNoteSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
    onDeleteClick,
  } = props;

  const { t } = useTranslate();

  return (
    <>
      <TableSearch
        columns={CONTACT_NOTE_SEARCH_COLUMNS(t, onDeleteClick)}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
      />
    </>
  );
};
export default memo(ContactNoteSearchResults);
